import React from 'react'

export default function Map() {
    return(
        <div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d817.4443029714442!2d-111.93726390630479!3d40.591608659912545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x875288c702634df5%3A0xc72f2938e8354181!2s8777%20S%20Redwood%20Rd%20%23250%2C%20West%20Jordan%2C%20UT%2084088!5e0!3m2!1sen!2sus!4v1711977685201!5m2!1sen!2sus" title='google-map' height="450" frameBorder="0" style={{border:0, width: '100vw'}} allowFullScreen=""></iframe>
        </div>
    )
}
